import { InjectionToken } from '@angular/core'
import { Action, ActionReducer, createReducer, on } from '@ngrx/store'
import * as DtoActions from './dto.actions'
import { initialDtoState, dtoStateAdapter, DtoState, DtoWrapper } from './dto.state'

const dtoReducer = createReducer(
  initialDtoState,
  on(DtoActions.getDtoSucceeded, (state, action) => {
    return dtoStateAdapter.upsertOne(action.dto, state)
  }),
  // on(DtoActions.getDtoAlreadyInStore, (state, _) => {
  //     const dw = new DtoWrapper();
  //     dw.dtoKey = "xxx";
  //     return dtoStateAdapter.upsertOne(dw, state);
  // }),
  on(DtoActions.setPendingState, (state, action) => {
    if (action.cancelPending) {
      return dtoStateAdapter.removeOne(action.storeId, state)
    } else {
      const ew = new DtoWrapper()
      ew.dtoKey = action.storeId
      ew.pending = true
      return dtoStateAdapter.upsertOne(ew, state)
    }
  }),
  on(DtoActions.setPendingStateForExistingEntity, (state, action) => {
    return dtoStateAdapter.upsertOne(action.dto, state)
  }),
  on(DtoActions.upsertDTO, (state, action) => {
    return dtoStateAdapter.upsertOne(action.dto, state)
  }),
  on(DtoActions.upsertDTOs, (state, action) => {
    return dtoStateAdapter.upsertMany(action.dtos, state)
  }),
  on(DtoActions.resetAllDTOs, (state, _) => {
    return dtoStateAdapter.removeAll(state)
  }),
  on(DtoActions.removeDTO, (state, action) => dtoStateAdapter.removeOne(action.id, state))
)

export function reducer(state: DtoState | undefined, action: Action) {
  return dtoReducer(state, action)
}

export const DTO_REDUCER = new InjectionToken<ActionReducer<DtoState>>('DTO Reducer')
